import { writable, readable } from 'svelte/store'
import { tutorial } from './live-data'

export const tutoStep = writable(-1)
export const tutoSize = readable(-1, set => {
  return tutorial.subscribe($tuto => {
    set($tuto.length)
  })
})
